import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  root: {
    color: theme.palette.common.black,
    cursor: 'pointer',
    '& $subList': {
      padding: theme.spacing(0, 2),
    },
  },
  expandHeader: {
    alignItems: 'center',
    background: 'none',
    border: 'none',
    color: 'inherit',
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'space-between',
    outline: 'none',
    width: '100%',
  },
  label: {
    fontSize: '14px',
    lineHeight: '24px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  labelContainer: {
    borderRadius: theme.shape.borderRadius,
    boxSizing: 'border-box',
    padding: theme.spacing(1, 2),
  },
  link: {
    display: 'flex',
    '&.active': {
      backgroundColor: 'rgba(116, 116, 128, 0.08)',
    },
    '&:hover': {
      backgroundColor: 'rgba(116, 116, 128, 0.06)',
    },
  },
  rotate180: {
    transform: 'rotate(180deg)',
  },
  subList: {},
}));
